module.exports = __webpack_public_path__ + "static/media/OS_hero.ed4eabc9.jpg";